// General
import "../CSS/index.css";
import "leaflet/dist/leaflet.css";
import { Switch, Route } from "react-router-dom";
import { client } from "../hooks/Client";
import Layout from "../components/layout/Layout";
import LayoutOpen from "../components/layout/LayoutOpen";
import RequirePermission from "../components/common/RequirePermission";

// Auth
import Profile from "../pages/auth/Profile";

// Public routes
import getPublicRoutes from "./PublicRoutes";

// Layout
import Helpdesk from "../pages/layout/Helpdesk";
import Updates from "../pages/layout/Updates";
import UpdateHighlight from "../pages/layout/UpdateHighlight";
import SROI from "../pages/measurementPlan/SROI";
import QualityCheck from "../pages/layout/QualityCheck";
import Impactmarket from "../pages/financing/Impactmarket";
import Notifications from "../pages/layout/Notifications";
import Agenda from "../pages/layout/Agenda";
import Insights from "../pages/Insights/Insights";

// Dashboard
import Dashboard from "../pages/dashboard/Dashboard";
import ParticipationValueDetail from "../pages/dashboard/ParticipationValueDetail";
import PortfolioValueDetail from "../pages/dashboard/PortfolioValueDetail";
import MaterialOutcomesDetail from "../pages/dashboard/MaterialOutcomesDetail";
import ParticipationBenchmarkDetails from "../pages/dashboard/ParticipationBenchmarkDetails";
import ImpactPerEuroDetail from "../pages/dashboard/ImpactPerEuroDetail";
import DataQualityDetail from "../pages/dashboard/DataQualityDetail";
import DataQualityDimensionDetail from "../pages/dashboard/DataQualityDimensionDetail";
import BenchmarksDetails from "../pages/dashboard/BenchmarksDetails";
import BenchmarkCompanyDetail from "../pages/dashboard/BenchmarkCompanyDetail";
import BenchmarkActivityPage from "../pages/dashboard/BenchmarkActivityPage";

// Portfolio
import Portfolio from "../pages/portfolio/Portfolio";
import Projects from "../pages/portfolio/Projects";
import SynchronisationsPortfolio from "../pages/portfolio/Synchronisations";
import ProjectDetails from "../pages/portfolio/ProjectDetails";
import SyncDetails from "../pages/portfolio/SyncDetails";
import Progress from "../pages/portfolio/Progress";
import ProjectsOverview from "../pages/portfolio/ProjectsOverview";
import SubscriptionsOverview from "../pages/admin/SubscriptionsOverview";
import PlatformRevenue from "../pages/admin/PlatformRevenue";
import PlatformChurn from "../pages/admin/PlatformChurn";
import UpdatesMailing from "../pages/admin/UpdatesMailing";

// ImpactStrategy
import Impactstrategy from "../pages/impactStrategy/Impactstrategy";
import OrganisationContext from "../pages/impactStrategy/OrganisationContext";
import Stakeholders from "../pages/impactStrategy/Stakeholders";
import SubTargetgroups from "../pages/impactStrategy/SubTargetgroups";
import Activities from "../pages/impactStrategy/Activities";
import TocMechanisms from "../pages/impactStrategy/TocMechanisms";
import Effects from "../pages/impactStrategy/Effects";
import PrintOutputs from "../pages/impactStrategy/PrintOutputs";
import AddOutputs from "../pages/impactStrategy/AddOutputs";

// Measurementplan
import SelectKPIs from "../pages/measurementPlan/SelectKPIs";
import SelectKPIsOutputs from "../pages/measurementPlan/SelectKPIsOutputs";
import ResearchAnalysis from "../pages/measurementPlan/ResearchAnalysis";
import ResearchResultsOpenQuestionAnalysis from "../pages/measurementPlan/ResearchResultsOpenQuestionAnalysis";
import KPIs from "../pages/measurementPlan/KPIs";
import QuestionaireBuilder from "../pages/measurementPlan/QuestionaireBuilder";
import ResearchBuilder from "../pages/measurementPlan/ResearchBuilder";
import Measurementplan from "../pages/measurementPlan/Measurementplan";
import Questionnaires from "../pages/measurementPlan/Questionnaires";
import ResearchResults from "../pages/measurementPlan/ResearchResults";
import ResearchResultsForms from "../pages/measurementPlan/ResearchResultsForms";
import ResearchResponses from "../pages/measurementPlan/ResearchResponses";
import ResponseDetails from "../pages/measurementPlan/ResponseDetails";
import Research from "../pages/measurementPlan/Research";
import Events from "../pages/measurementPlan/events/Events";
import AddResults from "../pages/measurementPlan/AddResults";
import ShareQuestionnaire from "../pages/measurementPlan/ShareQuestionnaire";
import IndicatorQuestionDetail from "../pages/measurementPlan/IndicatorQuestionDetail";
import AddIndicatorsToQuestionaire from "../pages/measurementPlan/AddIndicatorsToQuestionaire";
import AddIndicators from "../pages/measurementPlan/AddIndicators";
import PrintQuestionaire from "../pages/measurementPlan/PrintQuestionaire";
import PrintIntakeForm from "../pages/adresses/PrintIntakeForm";
import Qrcode from "../pages/measurementPlan/Qrcode";
import Letter from "../pages/measurementPlan/Letter";
import AddStandardEffectsToQuestionaire from "../pages/measurementPlan/AddStandardEffectsToQuestionaire";
import Storytelling from "../pages/measurementPlan/Storytelling";
import StorytellingInterviewDetail from "../pages/measurementPlan/StorytellingInterviewDetail";
import MechanismReview from "../pages/measurementPlan/MechanismReview";
import AddEvent from "../pages/measurementPlan/events/AddEvent";
import ImportResults from "../pages/measurementPlan/ImportResults";
import ImportMeasureMoment from "../pages/measurementPlan/ImportMeasureMoment";
import AddOnstructuredInterview from "../pages/measurementPlan/AddOnstructuredInterview";
import EditEvent from "../pages/measurementPlan/events/EditEvent";
import EventBuilder from "../pages/measurementPlan/events/EventBuilder";
import EventResults from "../pages/measurementPlan/events/EventResults";
import EventResultsDetail from "../pages/measurementPlan/events/EventResultsDetail";
import ResearchResultsSessions from "../pages/measurementPlan/ResearchResultsSessions";

// Analysis
import Analysis from "../pages/analysis/Analysis";
import AddAnalysis from "../pages/analysis/AddAnalysis";
import AddAIAnalysis from "../pages/analysis/AddAIAnalysis";
import EditAnalysis from "../pages/analysis/EditAnalysis";
import DeepAnalysisPage from "../pages/analysis/DeepAnalysisPage";
import EmailQuestionaire from "../pages/measurementPlan/EmailQuestionaire";

// Communication
import Communication from "../pages/communication/Communication";
import LiveReportBuilder from "../pages/communication/LiveReportBuilder";
import LiveReports from "../pages/communication/LiveReports";
import Synchronisations from "../pages/communication/Synchronisations";
import SynchronisationBuilder from "../pages/communication/SynchronisationBuilder";
import PrintLiveReport from "../pages/communication/PrintLiveReport";
import AIAnalysis from "../pages/communication/AIAnalysis";
import LiveReports2 from "../pages/communication/LiveReports2";
import LivereportTemplates from "../pages/communication/LivereportTemplates";
import LivereportTemplateBuilder from "../pages/communication/LivereportTemplateBuilder";
import LivereportTemplateViewer from "../pages/communication/LivereportTemplateViewer";
import LiveReportPrint from "../pages/communication/LiveReportPrint";
import ImpactInBeeld from "../pages/communication/ImpactInBeeld";

// Financing
import FundDetails from "../pages/financing/FundDetails";
import Funds from "../pages/financing/Funds";
import FundsDatabase from "../pages/financing/FundsDatabase";
import Financing from "../pages/financing/Financing";
import AllFunds from "../pages/financing/AllFunds";
import MyFinanciers from "../pages/financing/MyFinanciers";

// Personas
import Personas from "../pages/personas/Personas";
import PersonasExplainer from "../pages/personas/PersonasExplainer";
import ReserachResultsPersonas from "../components/personas/research/ReserachResultsPersonas";
import ResearchResponsesPersonas from "../components/personas/research/ResearchResponsesPersonas";
import ResearchResultsPersonasForms from "../components/personas/research/ResearchResultsPersonasForms";
import PersonaReportDetail from "../components/personas/reports/PersonaReportDetail";
import PersonaGoalDetail from "../components/personas/goals/PersonaGoalDetail";
import PersonaBuilder from "../pages/personas/PersonaBuilder";
import PersonaDashboard from "../components/personas/Dashboard/PersonaDashboard";
import PersonaPresenceReportDetails from "../components/personas/reports/PersonaPresenceReportDetails";
import PresenceReport from "../components/personas/reports/PresenceReport";
import PrintPresenceReport from "../components/personas/reports/PrintPresenceReport";
import PersonaMethodeDetails from "../components/personas/PersonaMethodeDetails";
import ReportStandardDetails from "../components/personas/ReportStandardDetails";

// Adresses
import HouseVisitsExplainer from "../pages/adresses/AdressesExplainer";
import Overview from "../pages/adresses/Overview";
import StatusPerPeriode from "../pages/adresses/StatusPerPeriode";
import AdressDetails from "../pages/adresses/AdressDetails";
import NoteDetail from "../components/adresses/notes/NoteDetail";
import IntakeFormBuilder from "../pages/adresses/IntakeFormBuilder";
import Intakeforms from "../pages/adresses/Intakeforms";
import Materials from "../pages/materials/Materials";
import Billing from "../pages/billing/Billing";
import WervingsactiesOverview from "../pages/wervingsacties/Overview";
import WervingsactieDetail from "../pages/wervingsacties/Detail";

// Impact management
import TaskDetails from "../components/tasks/TaskDetails";

// Admin
import Subscription from "../pages/admin/Subscription";
import Settings from "../pages/admin/Settings";

// Superadmin
import AdminFunds from "../pages/superadmin/AdminFunds";
import FundBuilder from "../pages/superadmin/FundBuilder";
import MetaData from "../pages/superadmin/MetaData";
import Intelligence from '../pages/intelligence/Intelligence';
import DeccaConversationsOverview from '../pages/decca/DeccaConversationsOverview';
import DeccaConversationDetail from '../pages/decca/DeccaConversationDetail';
import InsightDetail from '../pages/intelligence/InsightDetail';
import ThemeDetail from '../pages/intelligence/ThemeDetail';
import CellDetail from '../pages/intelligence/CellDetail';
import MaterialBenchmarkDetail from '../pages/intelligence/MaterialBenchmarkDetail';

// Open
import LiveReportOpen from "../pages/open/LiveReportOpen";
import LiveReportOpen2 from "../pages/open/LiveReportOpen2";
import QuestionnaireOpen from "../pages/open/QuestionnaireOpen";
import Impactplan from "../pages/open/Impactplan";
import Prullenbak from "../pages/prullenbak/Prullenbak";
import EventOpen from "../components/open/EventOpen";
import IntakeFormOpen from "../components/open/intakeForms/IntakeFormOpen";
import { LiveReportCrudContextProvider } from "../components/liveReport/reportBuilder2/context/LiveReportCrudContext";


const Main = () => {
  return (
    <>
      <Switch>
        {/* Insert public routes, React Router v5 does not support nested routing components */}
        {getPublicRoutes()}

        {/* Auth */}
        <Route path={`/${client}/Profile`}>
          <Layout>
            <Profile />
          </Layout>
        </Route>

        {/* Layout */}
        <Route exact path={`/${client}`}>
          <Layout>
            <Dashboard />
          </Layout>
        </Route>
        <Route path={`/${client}/notifications`}>
          <Layout>
            <Notifications />
          </Layout>
        </Route>
        <Route path={`/${client}/home`}>
          <Layout>
            <Dashboard/>
          </Layout>
        </Route>
        <Route path={`/${client}/helpdesk`}>
          <Layout>
            <Helpdesk />
          </Layout>
        </Route>
        {/* Het uitgelichte verhaal van één update, met schermafbeelding. Moet
            VOOR /updates staan: de Switch pakt de eerste route die matcht, en
            /updates matcht zonder `exact` ook /updates/<id>. */}
        <Route path={`/${client}/updates/:id`}>
          <Layout>
            <UpdateHighlight />
          </Layout>
        </Route>

        {/* Updates — wat is er nieuw. Geen permissiecheck: iedereen mag de
            pagina zien, de gating zit per update op de afgenomen modules. */}
        <Route path={`/${client}/updates`}>
          <Layout>
            <Updates />
          </Layout>
        </Route>
        {/* Prullenbak — alles wat in deze omgeving is verwijderd, met de
            mogelijkheid het terug te zetten. Achter het beheerrecht: wie niets
            mag aanpassen, hoort ook niets terug te kunnen halen. */}
        <Route path={`/${client}/prullenbak`}>
          <Layout>
            <RequirePermission permission="settings.view">
              <Prullenbak />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/qualitycheck`}>
          <Layout>
            <QualityCheck />
          </Layout>
        </Route>
        <Route path={`/${client}/agenda`}>
          <Layout>
            <RequirePermission permission="calendar.view">
              <Agenda />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/insights`}>
          <Layout>
            <Insights />
          </Layout>
        </Route>
        {/* Dashboard */}
        <Route path={`/${client}/dashboard`}>
          <Layout>
            <Dashboard />
          </Layout>
        </Route>
        <Route path={`/${client}/maatschappelijke-waarde`}>
          <Layout>
            <ParticipationValueDetail />
          </Layout>
        </Route>
        <Route path={`/${client}/portfolio-maatschappelijke-waarde`}>
          <Layout>
            <RequirePermission permission="portfolio.view">
              <PortfolioValueDetail />
            </RequirePermission>
          </Layout>
        </Route>
        {/* Doorklik vanaf de tegels Bespaarde CO2 / Bespaard op energierekening
            (Actienetwerk Energiearmoede + Deccos). De callable poort op tenant.
            AI-CONTEXT: See docs/features/materiaal-uitkomsten-tegels.md */}
        <Route path={`/${client}/materiaal-besparingen`}>
          <Layout>
            <RequirePermission permission="portfolio.view">
              <MaterialOutcomesDetail />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/impact-per-euro`}>
          <Layout>
            <ImpactPerEuroDetail />
          </Layout>
        </Route>
        <Route path={`/${client}/datakwaliteit/:dimension`}>
          <Layout>
            <DataQualityDimensionDetail />
          </Layout>
        </Route>
        <Route path={`/${client}/datakwaliteit`}>
          <Layout>
            <DataQualityDetail />
          </Layout>
        </Route>
        <Route path={`/${client}/participatiebenchmark`}>
          <Layout>
            <ParticipationBenchmarkDetails />
          </Layout>
        </Route>
        {/* Portfolio */}
        <Route path={`/${client}/portfolio`}>
          <Layout>
            <RequirePermission permission="portfolio.view">
              <Portfolio />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/projects`}>
          <Layout>
            <RequirePermission permission="portfolio.view">
              <Projects />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/synchronisationsportfolio`}>
          <Layout>
            <RequirePermission permission="portfolio.view">
              <SynchronisationsPortfolio />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/portfolioprojectdetails`}>
          <Layout>
            <RequirePermission permission="portfolio.view">
              <ProjectDetails />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/portfoliosyncdetails`}>
          <Layout>
            <RequirePermission permission="portfolio.view">
              <SyncDetails />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/progress`}>
          <Layout>
            <RequirePermission permission="portfolio.view">
              <Progress />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/projectsOverview`}>
          <Layout>
            <RequirePermission permission="portfolio.view">
              <ProjectsOverview />
            </RequirePermission>
          </Layout>
        </Route>

        {/* Abonnementenoverzicht — bereikbaar vanaf de MRR-tegel op het
            beheerdersdashboard. De pagina zelf haalt haar gegevens via een
            callable die op de beheertenant gate't; deze route is een
            weergavefilter, geen toegangsfilter.
            Spec: docs/features/subscriptions-overview-page.md */}
        <Route path={`/${client}/subscriptionsOverview`}>
          <Layout>
            <RequirePermission permission="portfolio.view">
              <SubscriptionsOverview />
            </RequirePermission>
          </Layout>
        </Route>

        {/* Omzet over de tijd (klik op het bedrag van de MRR-tegel) en de
            gestopte klanten (churntegel). Zelfde opzet als hierboven: de
            callables gaten op de beheertenant, de route is een weergavefilter.
            Spec: docs/features/platform-revenue-churn-trend.md */}
        <Route path={`/${client}/platformRevenue`}>
          <Layout>
            <RequirePermission permission="portfolio.view">
              <PlatformRevenue />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/platformChurn`}>
          <Layout>
            <RequirePermission permission="portfolio.view">
              <PlatformChurn />
            </RequirePermission>
          </Layout>
        </Route>

        {/* Updates mailen — het verzendscherm van de updatemailing, alleen
            zinvol vanuit de Deccos-beheertenant. Geen RequirePermission: de
            echte poort staat server-side op de Cloud Functions
            (isCallerGlobalSuperAdmin voor het verzenden, lidmaatschap van de
            beheertenant voor het bekijken). Wie de URL intypt krijgt hier een
            leeg scherm met een foutmelding van de server, geen gegevens.
            Spec: docs/features/updates-mailing.md */}
        <Route path={`/${client}/updatesmailing`}>
          <Layout>
            <UpdatesMailing />
          </Layout>
        </Route>

        {/* ImpactStrategy */}
        <Route path={`/${client}/Activities`}>
          <Layout>
            <RequirePermission permission="strategy.view">
              <Activities />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/Stakeholders`}>
          <Layout>
            <RequirePermission permission="strategy.view">
              <Stakeholders />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/subtargetgroups`}>
          <Layout>
            <RequirePermission permission="strategy.view">
              <SubTargetgroups />
            </RequirePermission>
          </Layout>
        </Route>
        {/* Duplicate: */}
        {/* <Route path={`/${client}/Agenda`}>
          <Layout>
            <Agenda />
          </Layout>
        </Route> */}
        <Route path={`/${client}/Mechanisms`}>
          <Layout>
            <RequirePermission permission="strategy.view">
              <TocMechanisms />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/effects`}>
          <Layout>
            <RequirePermission permission="strategy.view">
              <Effects />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/organisationcontext`}>
          <Layout>
            <RequirePermission permission="strategy.view">
              <OrganisationContext />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/impactstrategy`}>
          <Layout>
            <RequirePermission permission="strategy.view">
              <Impactstrategy />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/printoutputs`}>
          <PrintOutputs />
        </Route>
        <Route path={`/${client}/addoutputs/:id`}>
         <Layout>
          <RequirePermission permission="strategy.view">
            <AddOutputs />
          </RequirePermission>
         </Layout>
        </Route>
        

        {/* Measurementplan */}
        <Route path={`/${client}/selectkpis`}>
          <Layout>
            <RequirePermission permission="measurement.view">
              <SelectKPIs />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/selectkpisoutputs`}>
          <Layout>
            <RequirePermission permission="measurement.view">
              <SelectKPIsOutputs />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/researchbuilder`}>
          <Layout>
            <RequirePermission permission="measurement.view">
              <ResearchBuilder />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/importmeasuremoment/:researchId/:momentId`}>
          <Layout>
            <ImportMeasureMoment />
          </Layout>
        </Route>
        <Route path={`/${client}/measurementplan`}>
          <Layout>
            <RequirePermission permission="measurement.view">
              <Measurementplan />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/researchanalysis`}>
          <Layout>
            <RequirePermission permission="measurement.view">
              <ResearchAnalysis />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/questionairebuilder`}>
          <Layout>
            <RequirePermission permission="measurement.view">
              <QuestionaireBuilder />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/kpis`}>
          <Layout>
            <RequirePermission permission="measurement.view">
              <KPIs />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/researchresultsopenquestionanalysis`}>
          <Layout>
            <RequirePermission permission="measurement.view">
              <ResearchResultsOpenQuestionAnalysis />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/sharequestionnaire`}>
          <Layout>
            <RequirePermission permission="measurement.view">
              <ShareQuestionnaire />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/research`}>
          <Layout>
            <RequirePermission permission="measurement.view">
              <Research />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/addresults`}>
          <Layout>
            <RequirePermission permission="measurement.view">
              <AddResults />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/events`}>
          <Layout>
            <RequirePermission permission="measurement.view">
              <Events />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/shareevent/:id`}>
          <Layout>
            <RequirePermission permission="measurement.view">
              <ShareQuestionnaire />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/researchresults`}>
          <Layout>
            <RequirePermission permission="measurement.view">
              <ResearchResults />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/researchresponses`}>
          <Layout>
            <RequirePermission permission="measurement.view">
              <ResearchResponses />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/responsedetails`}>
          <Layout>
            <ResponseDetails />
          </Layout>
        </Route>
        <Route path={`/${client}/questionnaires`}>
          <Layout>
            <RequirePermission permission="measurement.view">
              <Questionnaires />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/SROI`}>
          <Layout>
            <RequirePermission permission="measurement.view">
              <SROI />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/indicatorquestiondetail`}>
          <Layout>
            <RequirePermission permission="measurement.view">
              <IndicatorQuestionDetail />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/addindicatorstoquestionaire`}>
          <Layout>
            <RequirePermission permission="measurement.view">
              <AddIndicatorsToQuestionaire />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/addindicators`}>
          <Layout>
            <RequirePermission permission="measurement.view">
              <AddIndicators />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/addstandardeffectstoquestionaire`}>
          <Layout>
            <RequirePermission permission="measurement.view">
              <AddStandardEffectsToQuestionaire />
            </RequirePermission>
          </Layout>
        </Route>
        <Route exact path={`/${client}/storytellinginterviewdetail/:id`}>
          <Layout>
            <RequirePermission permission="measurement.view">
              <StorytellingInterviewDetail />
            </RequirePermission>
          </Layout>
        </Route>
        <Route exact path={`/${client}/storytellinginterviewmechanisms/:id`}>
          <Layout>
            <RequirePermission permission="measurement.view">
              <MechanismReview />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/storytelling`}>
          <Layout>
            <RequirePermission permission="measurement.view">
              <Storytelling />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/addevent`}>
          <Layout>
            <RequirePermission permission="measurement.view">
              <AddEvent />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/analysis`}>
          <Layout>
            <RequirePermission permission="measurement.view">
              <Analysis />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/addanalysis`}>
          <Layout>
            <RequirePermission permission="measurement.view">
              <AddAnalysis/>
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/addaianalysis`}>
          <Layout>
            <AddAIAnalysis/>
          </Layout>
        </Route>
        <Route path={`/${client}/editanalysis`}>
          <Layout>
            <RequirePermission permission="measurement.view">
              <EditAnalysis />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/deepanalysis`}>
          <Layout>
            <DeepAnalysisPage />
          </Layout>
        </Route>
        <Route path={`/${client}/importresearchresults`}>
          <Layout>
            <RequirePermission permission="measurement.view">
              <ImportResults />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/addonstructuredinterview`}>
          <Layout>
            <RequirePermission permission="measurement.view">
              <AddOnstructuredInterview />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/editevent`}>
          <Layout>
            <RequirePermission permission="measurement.view">
              <EditEvent />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/researchresultsforms`}>
          <Layout>
            <RequirePermission permission="measurement.view">
              <ResearchResultsForms />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/eventbuilder`}>
          <Layout>
            <RequirePermission permission="measurement.view">
              <EventBuilder />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/eventresults`}>
          <Layout>
            <RequirePermission permission="measurement.view">
              <EventResults />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/eventresultsdetail`}>
          <Layout>
            <RequirePermission permission="measurement.view">
              <EventResultsDetail />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/emailquestionnaire`}>
          <Layout>
            <RequirePermission permission="measurement.view">
              <EmailQuestionaire />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/researchresultssessions`}>
          <Layout>
            <RequirePermission permission="measurement.view">
              <ResearchResultsSessions />
            </RequirePermission>
          </Layout>
        </Route>

        {/* Personas */}
        <Route path={`/${client}/personadashboard`}>
          <Layout>
            <RequirePermission permission="personas.view">
              <PersonaDashboard />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/personas`}>
          <Layout>
            <RequirePermission permission="personas.view">
              <Personas />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/researchresultspersonasforms`}>
          <Layout>
            <RequirePermission permission="personas.view">
              <ResearchResultsPersonasForms />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/researchresponsespersonas`}>
          <Layout>
            <RequirePermission permission="personas.view">
              <ResearchResponsesPersonas/>
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/researchresultspersonas`}>
          <Layout>
            <RequirePermission permission="personas.view">
              <ReserachResultsPersonas />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/personasexplainer`}>
          <Layout>
            <RequirePermission permission="personas.view">
              <PersonasExplainer />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/personareportdetail`}>
          <Layout>
            <RequirePermission permission="personas.view">
              <PersonaReportDetail />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/personagoaldetail`}>
          <Layout>
            <RequirePermission permission="personas.view">
              <PersonaGoalDetail />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/personabuilder`}>
          <Layout>
            <RequirePermission permission="personas.view">
              <PersonaBuilder />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/personapresencereportdetail`}>
          <Layout>
            <RequirePermission permission="personas.view">
              <PersonaPresenceReportDetails />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/presencereport`}>
          <Layout>
            <RequirePermission permission="personas.view">
              <PresenceReport />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/printpresencereport`}>
          <PrintPresenceReport />
        </Route>
        <Route path={`/${client}/personamethodedetails`}>
          <Layout>
            <RequirePermission permission="personas.view">
              <PersonaMethodeDetails />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/personareportstandarddetails`}>
          <Layout>
            <RequirePermission permission="personas.view">
              <ReportStandardDetails />
            </RequirePermission>
          </Layout>
        </Route>

        {/* Adresses */}
        <Route path={`/${client}/housevisitsexplainer`}>
          <Layout>
            <RequirePermission permission="housevisits.view">
              <HouseVisitsExplainer />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/housevisitsoverview`}>
          <Layout>
            <RequirePermission permission="housevisits.view">
              <Overview />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/housevisitsstatus`}>
          <Layout>
            <RequirePermission permission="housevisits.view">
              <StatusPerPeriode />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/adressdetails/:id`}>
          <Layout>
            <RequirePermission permission="addresses.view">
              <AdressDetails />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/adressnotedetail/:adressId/:noteId`}>
          <Layout>
            <RequirePermission permission="addresses.view">
              <NoteDetail />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/intakeformbuilder/:id`}>
          <Layout>
            <RequirePermission permission="forms.view">
              <IntakeFormBuilder />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/intakeforms`}>
          <Layout>
            <RequirePermission permission="forms.view">
              <Intakeforms />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/materials`}>
          <Layout>
            <RequirePermission permission="housevisits.view">
              <Materials />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/facturatie`}>
          <Layout>
            <RequirePermission permission="billing.view">
              <Billing />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/wervingsacties`}>
          <Layout>
            <RequirePermission permission="housevisits.view">
              <WervingsactiesOverview />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/wervingsactie/:id`}>
          <Layout>
            <RequirePermission permission="housevisits.view">
              <WervingsactieDetail />
            </RequirePermission>
          </Layout>
        </Route>

        {/* Communication */}
        <Route path={`/${client}/communication`}>
          <Layout>
            <RequirePermission permission="reports.view">
              <Communication />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/livereportbuilder`}>
          <Layout>
            <RequirePermission permission="reports.view">
              <LiveReportBuilder />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/livereports`}>
          <Layout>
            <RequirePermission permission="reports.view">
              <LiveReports />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/synchronisations`}>
          <Layout>
            <RequirePermission permission="reports.view">
              <Synchronisations />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/synchronisationbuilder`}>
          <Layout>
            <RequirePermission permission="reports.view">
              <SynchronisationBuilder />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/printlivereport`}>
          <PrintLiveReport />
        </Route>
        <Route path={`/${client}/aianalysis`}>
          <Layout>
            <RequirePermission permission="reports.view">
              <AIAnalysis />
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/livereports2`}>
          <Layout>
            <RequirePermission permission="reports.view">
              <LiveReportCrudContextProvider>
                <LiveReports2 />
              </LiveReportCrudContextProvider>
            </RequirePermission>
          </Layout>
        </Route>
        <Route path={`/${client}/livereporttemplates`}>
          <Layout>
            <LivereportTemplates />
          </Layout>
        </Route>
        <Route path={`/${client}/livereporttemplatebuilder`}>
          <Layout>
            <LiveReportCrudContextProvider>
              <LivereportTemplateBuilder />
            </LiveReportCrudContextProvider>
          </Layout>
        </Route>
        <Route path={`/${client}/livereporttemplateviewer`}>
          <Layout>
            <LiveReportCrudContextProvider>
              <LivereportTemplateViewer />
            </LiveReportCrudContextProvider>
          </Layout>
        </Route>
        {/* Printvel: bewust zonder Layout, zodat menu en kopbalk niet op de PDF komen. */}
        <Route path={`/${client}/livereportprint`}>
          <RequirePermission permission="reports.view">
            <LiveReportCrudContextProvider>
              <LiveReportPrint />
            </LiveReportCrudContextProvider>
          </RequirePermission>
        </Route>
        <Route path={`/${client}/impactinbeeld`}>
          <Layout>
            <RequirePermission permission="reports.view">
              <ImpactInBeeld />
            </RequirePermission>
          </Layout>
        </Route>

        {/* Impact management */}
        <Route path={`/${client}/taskdetail`}>
          <Layout>
            <RequirePermission permission="tasks.view">
              <TaskDetails />
            </RequirePermission>
          </Layout>
        </Route>

        {/* Financing */}
        <Route path={`/${client}/funddetails`}>
          <Layout>
            <FundDetails />
          </Layout>
        </Route>
        <Route path={`/${client}/funds`}>
          <Layout>
            <Funds />
          </Layout>
        </Route>
        <Route path={`/${client}/fundsdatabase`}>
          <Layout>
            <FundsDatabase />
          </Layout>
        </Route>
        <Route path={`/${client}/financing`}>
          <Layout>
            <Financing />
          </Layout>
        </Route>
        <Route path={`/${client}/impactmarket`}>
          <Layout>
            <Impactmarket />
          </Layout>
        </Route>
        <Route path={`/${client}/allfunds`}>
          <Layout>
            <AllFunds />
          </Layout>
        </Route>
        <Route path={`/${client}/financiers`}>
          <Layout>
            <MyFinanciers />
          </Layout>
        </Route>

        {/* Admin & profile */}
        <Route path={`/${client}/subscription`}>
          <Layout>
            <Subscription />
          </Layout>
        </Route>
        <Route path={`/${client}/Settings`}>
          <Layout>
            <Settings />
          </Layout>
        </Route>

        {/* Duplicate: */}
        {/* <Route path={`/${client}/Profile`}>
          <Layout>
            <Profile />
          </Layout>
        </Route> */}

        {/* Superadmin */}
        <Route path={`/${client}/adminfunds`}>
          <Layout>
            <AdminFunds />
          </Layout>
        </Route>
        <Route path={`/${client}/fundbuilder`}>
          <Layout>
            <FundBuilder />
          </Layout>
        </Route>
        <Route path={`/${client}/metadata`}>
          <Layout>
            <MetaData />
          </Layout>
        </Route>
        {/* Intelligence — onderzoeksvragen met inzicht-cellen (beheertenant).
            De pagina's gaten zichzelf op isSuperAdminTenant; de Cloud Functions
            erachter gaten server-side, want frontend-gating is geen beveiliging. */}
        {/* Vóór de themaroute: zonder `exact` matcht die ook dit pad. */}
        <Route path={`/${client}/intelligence/thema/:themeId/cel/:cellId`}>
          <Layout>
            <CellDetail />
          </Layout>
        </Route>
        <Route path={`/${client}/intelligence/thema/:themeId`}>
          <Layout>
            <ThemeDetail />
          </Layout>
        </Route>
        <Route path={`/${client}/intelligence/materialen/:output`}>
          <Layout>
            <MaterialBenchmarkDetail />
          </Layout>
        </Route>
        <Route path={`/${client}/intelligence/inzicht/:insightId`}>
          <Layout>
            <InsightDetail />
          </Layout>
        </Route>
        <Route path={`/${client}/intelligence`}>
          <Layout>
            <Intelligence />
          </Layout>
        </Route>
        {/* Gesprekken die organisaties met Decca voerden (beheertenant).
            De detailroute staat vóór het overzicht: zonder `exact` matcht het
            overzicht ook het pad met de gesprek-id erachter.
            De Cloud Functions erachter gaten server-side op de beheertenant;
            deze routes zijn een weergavefilter, geen toegangsfilter. */}
        <Route path={`/${client}/deccagesprekken/:conversationId`}>
          <Layout>
            <DeccaConversationDetail />
          </Layout>
        </Route>
        <Route path={`/${client}/deccagesprekken`}>
          <Layout>
            <DeccaConversationsOverview />
          </Layout>
        </Route>
        <Route path={`/${client}/benchmarkdetails`}>
          <Layout>
            <BenchmarksDetails />
          </Layout>
        </Route>
        <Route path={`/${client}/benchmark/activity/:activityKey`}>
          <Layout>
            <BenchmarkActivityPage />
          </Layout>
        </Route>
        <Route path={`/${client}/benchmarkcompanydetail/:companyId/:effectId`}>
          <Layout>
            <BenchmarkCompanyDetail />
          </Layout>
        </Route>

        // Open
        <Route path={`/${client}/livereportopen`}>
          <LayoutOpen>
            <LiveReportOpen />
          </LayoutOpen>
        </Route>
        <Route path={`/${client}/livereportopen2`}>
          {/* <LayoutOpen> */}
            <LiveReportOpen2 />
          {/* </LayoutOpen> */}
        </Route>
        <Route path={`/${client}/questionnaireopen`}>
          <LayoutOpen>
            <QuestionnaireOpen />
          </LayoutOpen>
        </Route>
        <Route path={`/impactplan`}>
          <LayoutOpen>
            <Impactplan />
          </LayoutOpen>
        </Route>
        <Route path={`/${client}/eventopen`}>
          <LayoutOpen>
            <EventOpen />
          </LayoutOpen>
        </Route>
        <Route path={`/${client}/intakeformopen`}>
          <LayoutOpen>
            <IntakeFormOpen />
          </LayoutOpen>
        </Route>

        // Print
        <Route path={`/${client}/qrcode`}>
          <Qrcode />
        </Route>
        <Route path={`/${client}/letter`}>
          <Letter />
        </Route>
        <Route path={`/${client}/printquestionaire`}>
          <PrintQuestionaire />
        </Route>
        <Route path={`/${client}/printintakeform`}>
          <PrintIntakeForm />
        </Route>

      </Switch>
    </>
  );
};

export default Main;
